import { render } from "./Municipio.vue?vue&type=template&id=50a65cd6"
import script from "./Municipio.vue?vue&type=script&lang=js"
export * from "./Municipio.vue?vue&type=script&lang=js"

import "./Municipio.vue?vue&type=style&index=0&id=50a65cd6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__